import OnboardingInfoModal from "./OnboardingInfoModal";

export default OnboardingInfoModal;
